

































































import BaseComponent from '@/components/base-component.vue';
import ClientUnitForm from '@/components/client-units/client-unit-form.vue';
import UiCnpjFormat from '@/components/UI/cnpj-format.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import WhatsappButton from '@/components/UI/whatsapp-button.vue';
import { filterByText } from '@/helpers/filterByText';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { UnidadesFilterDTO } from '@/interfaces/clientUnit';
import ClientUnitModel from '@/models/client-unit-model';
import * as service from '@/services/client-unit';
import Component from 'vue-class-component';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    ClientUnitForm,
    UiSelectClients,
    UiCnpjFormat,
    WhatsappButton
  },
})
export default class Unit extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filter: any = {
    term: '',
    client: null,
    status: null,
  };

  public statusList: any[] = [
    {
      value: null,
      label: 'Todos',
    },
    {
      value: true,
      label: 'Ativo',
    },
    {
      value: false,
      label: 'Inativo',
    },
  ];

  public form: any = {
    valid: false,
    rules: {
      cnpj: [(v) => !!v || 'Digite o CNPJ'],
      name: [(v) => !!v || 'Digite o nome'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public headers: any = [
    { text: 'Cliente', value: 'cliente.nome' },
    { text: 'Nome', value: 'nome' },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];
  public data: ClientUnitModel[] = [];
  public item: any = {};

  public beforeMount(): void {
    this.load();
  }

  public onFilter(): void {
    this.load();
  }

  public onEditItem(item: ClientUnitModel): void {
    this.loader.start('Carregando item...');
    service.getClientUnit(item.id).subscribe(
      (data) => {
        this.item = data;
        this.formOpen = true;
        this.formOpen = true;
        this.loader.stop();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
      },
    );
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = search.toString().toLowerCase();
    return items.filter((row) => {
      return (
        filterByText(row, ['nome'], searchLower) ||
        filterByText(row.cliente, ['nome'], searchLower)
      );
    });
  }

  public saveItem(item: ClientUnitModel): void {
    this.closeForm();
    this.load();
  }

  public toggleItemStatus(item: ClientUnitModel, status: boolean): void {
    this.loader.start('Atualizando registro...');
    service.getClientUnit(item.id).subscribe((data) => {
      const _editableItem = new ClientUnitModel(data);
      const payload = _editableItem.toJson();
      payload.ativo = status;
      service.updateClientUnit(payload).subscribe(
        () => {
          item.ativo = status;
          this.loader.stop();
        },
        () => {
          this.loader.stop();
          this.toast.show('Ocorreu um erro ao atualizar a unidade', 'error');
        },
      );
    });
  }

  public newItem(): void {
    this.item = new ClientUnitModel();
    this.formIsEdit = false;
    this.formOpen = true;
  }

  public closeForm(): void {
    this.item = new ClientUnitModel();
    this.formOpen = false;
    resetModalScroll();
  }

  private load(): void {
    this.data = [];
    this.loading = true;

    const filter = {
      idCliente: !!this.filter.client ? this.filter.client.id : null,
      ativo: this.filter.status,
    };

    service.getClientUnits(filter).subscribe(
      (data) => {
        this.data = data.map((item) => new ClientUnitModel(item));
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }
}
